"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRANSPORTATION_GAS = exports.PAYING_BILLS = exports.HOUSING = exports.FOOD = exports.CASH = void 0;
var CASH = 'cash';
exports.CASH = CASH;
var FOOD = 'food';
exports.FOOD = FOOD;
var HOUSING = 'housing';
exports.HOUSING = HOUSING;
var PAYING_BILLS = 'payingBills';
exports.PAYING_BILLS = PAYING_BILLS;
var TRANSPORTATION_GAS = 'transportationGas';
exports.TRANSPORTATION_GAS = TRANSPORTATION_GAS;